// extracted by mini-css-extract-plugin
export default {"whatsapp-button":"WhatsappButton_whatsapp-button__kqQbG","logo":"WhatsappButton_logo__GMjpT"};